/**
 * State workshop collection — product cards first, dates live on the city PDP.
 */
(function (global) {
  var F = global.WorkshopCityFlow || {};
  var API = global.WorkshopCityEvents || {};
  var FETCH_TIMEOUT_MS =
    API && API.DEFAULT_FETCH_TIMEOUT_MS ? API.DEFAULT_FETCH_TIMEOUT_MS : 3000;
  var STATE_CATALOG_TIMEOUT_MS = 15000;
  var OVERLAY_MIN_DAYS = 90;
  var MAX_SLOTS_PER_PRODUCT = 400;
  var BROWSE_POLL_DAYS = 14;
  var BROWSE_POLL_PER_PRODUCT = 3;
  var TYPE_ORDER = ['mosaic', 'ceramic', 'resin', 'flower'];
  var STATE_NAMES = {
    AZ: 'Arizona',
    CA: 'California',
    ID: 'Idaho',
    NV: 'Nevada',
    OR: 'Oregon',
    UT: 'Utah',
    WA: 'Washington',
  };
  var TYPE_TITLES = {
    mosaic: 'Mosaic Lamp Workshop',
    ceramic: 'Ceramic Painting Workshop',
    flower: 'Flower Decorating Workshop',
    resin: 'Resin Art Workshop',
  };
  var TYPE_BADGES = {
    mosaic: 'Mosaic lamp',
    ceramic: 'Ceramic painting',
    flower: 'Flower decorating',
    resin: 'Resin art',
  };

  function parseData(root) {
    var sid = root.getAttribute('data-section-id');
    var el = document.getElementById('StateWorkshopData-' + sid);
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn('[state-workshop-collection] invalid JSON', e);
      return null;
    }
  }

  function slotDateKey(slot) {
    return F.slotDateKey ? F.slotDateKey(slot) : String((slot && slot.date_key) || '').slice(0, 10);
  }

  function slotBookable(slot) {
    return F.slotBookable ? F.slotBookable(slot) : true;
  }

  function parseDateKey(dateKey) {
    if (!dateKey) return null;
    var d = new Date(String(dateKey).slice(0, 10) + 'T12:00:00');
    if (isNaN(d.getTime())) return null;
    return d;
  }

  function isUpcomingDate(dateKey) {
    var d = parseDateKey(dateKey);
    if (!d) return false;
    var now = new Date();
    now.setHours(0, 0, 0, 0);
    return d >= now;
  }

  function isWithinNextDays(dateKey, days) {
    var d = parseDateKey(dateKey);
    if (!d) return false;
    var now = new Date();
    now.setHours(0, 0, 0, 0);
    var end = new Date(now);
    end.setDate(end.getDate() + Number(days));
    end.setHours(23, 59, 59, 999);
    return d >= now && d <= end;
  }

  function dateInRange(dateKey, dateRange) {
    if (!dateKey) return false;
    if (dateRange === '7') return isWithinNextDays(dateKey, 7);
    if (dateRange === '14') return isWithinNextDays(dateKey, 14);
    if (dateRange === '30') return isWithinNextDays(dateKey, 30);
    return isUpcomingDate(dateKey);
  }

  function normalizeWorkshopType(raw, label) {
    var key = String(raw || '').toLowerCase().trim();
    var text = (key + ' ' + String(label || '')).toLowerCase();
    if (/flower|floral/.test(text)) return { key: 'flower', label: 'Flower decorating' };
    if (text.indexOf('resin') >= 0) return { key: 'resin', label: 'Resin' };
    if (text.indexOf('ceramic') >= 0) return { key: 'ceramic', label: 'Ceramic' };
    if (text.indexOf('mosaic') >= 0) return { key: 'mosaic', label: 'Mosaic' };
    if (key) {
      return {
        key: key,
        label: label || key.charAt(0).toUpperCase() + key.slice(1),
      };
    }
    return { key: 'workshop', label: 'Workshop' };
  }

  function productType(product) {
    return normalizeWorkshopType(product && product.workshopType, product && product.workshopLabel);
  }

  function buildProductMaps(products) {
    var byId = {};
    var byHandle = {};
    (products || []).forEach(function (p) {
      if (p.id != null) byId[p.id] = p;
      if (p.handle) byHandle[p.handle] = p;
    });
    return { byId: byId, byHandle: byHandle };
  }

  function productFromCity(city, maps) {
    var handle = String(city.product_handle || city.handle || '').trim();
    var id = city.product_id;
    var fromLiquid =
      (id != null && maps.byId[id]) || (handle && maps.byHandle[handle]) || null;
    if (fromLiquid) return fromLiquid;

    var inferred = normalizeWorkshopType(city.workshop_type || handle, city.workshop_label);
    return {
      id: id,
      handle: handle,
      title: city.city_name || handle,
      url: city.product_url || (handle ? '/products/' + handle : ''),
      cityName: String(city.city_name || city.city || '').trim(),
      venueName: String(city.venue_name || '').trim(),
      workshopType: inferred.key,
      workshopLabel: inferred.label,
      priceFormatted: '',
      compareAtFormatted: '',
      featuredImageUrl: city.featured_image_url || '',
    };
  }

  function catalogCitiesToEvents(catalog, maps) {
    var events = [];
    (catalog.cities || []).forEach(function (city) {
      var product = productFromCity(city, maps);
      (city.slots || []).forEach(function (slot) {
        events.push({ slot: slot, product: product });
      });
    });
    return events;
  }

  function resolveLiveStateCatalogUrl(root) {
    return (
      (root && root.getAttribute('data-live-state-api-url')) ||
      (root && root.getAttribute('data-state-api-url')) ||
      (root && root.getAttribute('data-events-api-url')) ||
      ''
    );
  }

  function catalogHorizonDays(root) {
    var days = parseInt((root && root.getAttribute('data-fetch-horizon-days')) || '30', 10);
    if (!days || days < 1) return 30;
    return days;
  }

  function overlayHorizonDays(root) {
    return Math.max(catalogHorizonDays(root), OVERLAY_MIN_DAYS);
  }

  function sortSlots(slots) {
    return (slots || []).slice().sort(function (a, b) {
      return (slotDateKey(a) + String((a && (a.schema_start || a.time_label)) || '')).localeCompare(
        slotDateKey(b) + String((b && (b.schema_start || b.time_label)) || '')
      );
    });
  }

  function trimCitySlots(slots, days) {
    var kept = sortSlots(slots).filter(function (slot) {
      var dk = slotDateKey(slot);
      return isUpcomingDate(dk) && isWithinNextDays(dk, days);
    });
    if (kept.length > MAX_SLOTS_PER_PRODUCT) kept = kept.slice(0, MAX_SLOTS_PER_PRODUCT);
    return kept;
  }

  function trimCatalog(catalog, days) {
    if (!catalog || !catalog.cities) return catalog || { cities: [] };
    return {
      state: catalog.state,
      stats: catalog.stats,
      cities: (catalog.cities || []).map(function (city) {
        return Object.assign({}, city, { slots: trimCitySlots(city.slots, days) });
      }),
    };
  }

  function addUniqueGid(gids, seen, gid) {
    if (!gid || seen[gid]) return;
    seen[gid] = true;
    gids.push(gid);
  }

  function collectHorizonSlotGids(catalog, root, book) {
    var gids = [];
    var seen = {};
    var browseDays = Math.max(catalogHorizonDays(root), BROWSE_POLL_DAYS);
    var openHandle = book && book.isOpen && book.isOpen() && book.currentHandle ? book.currentHandle() : '';

    (catalog.cities || []).forEach(function (city) {
      var slots = city.slots || [];
      if (openHandle && (city.product_handle || city.handle) === openHandle) {
        slots.forEach(function (slot) {
          if (slot) addUniqueGid(gids, seen, slot.gid);
        });
        return;
      }
      var inRange = slots.filter(function (slot) {
        return slot && slot.gid && isWithinNextDays(slotDateKey(slot), browseDays);
      });
      var bookable = inRange.filter(slotBookable);
      var i;
      for (i = 0; i < BROWSE_POLL_PER_PRODUCT && i < bookable.length; i++) {
        addUniqueGid(gids, seen, bookable[i].gid);
      }
      if (inRange[0]) addUniqueGid(gids, seen, inRange[0].gid);
    });
    return gids;
  }

  function cardImageUrl(url, width) {
    var src = String(url || '');
    if (!src) return '';
    var next = src.replace(/([?&])width=\d+/g, '$1width=' + width);
    if (next.indexOf('width=') === -1) {
      next += (next.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width;
    }
    return next.replace(/_\d+x(?=\.)/g, '_' + width + 'x');
  }

  function cardsSignature(stats, workshopType, dateRange, city, page) {
    var parts = [workshopType || 'all', dateRange || 'all', city || 'all', String(page || 1)];
    Object.keys(stats || {})
      .sort()
      .forEach(function (handle) {
        var st = stats[handle] || {};
        parts.push(
          handle +
            ':' +
            (st.next || '') +
            ':' +
            (st.nextTime || '') +
            ':' +
            (st.bookableCount || 0) +
            ':' +
            (st.dateCount || 0)
        );
      });
    return parts.join('|');
  }

  function formatNextSessionLabel(slot, product) {
    if (!slot) return '';
    var dk = slotDateKey(slot);
    var parts = [];
    if (dk) parts.push(formatShortDate(dk));
    var city = product && product.cityName ? String(product.cityName).trim() : '';
    if (city) parts.push(city);
    return parts.join(' · ');
  }

  function recomputeStatsFromEvents(events) {
    var bookable = (events || []).filter(function (ev) {
      return slotBookable(ev.slot);
    });
    bookable.sort(function (a, b) {
      return slotDateKey(a.slot).localeCompare(slotDateKey(b.slot));
    });
    return {
      upcoming_session_count: bookable.length,
      next_session_label: bookable.length
        ? formatNextSessionLabel(bookable[0].slot, bookable[0].product)
        : '',
    };
  }

  function stopStateLivePoll(root) {
    if (root && root.__swcLivePoll && typeof root.__swcLivePoll.stop === 'function') {
      root.__swcLivePoll.stop();
    }
    if (root) delete root.__swcLivePoll;
  }

  function startStateLivePoll(root, data, onUpdate) {
    stopStateLivePoll(root);
    var LiveAPI = global.WorkshopCityEvents || {};
    if (!LiveAPI.startLiveStatePoll) return;

    var CFG = global.WorkshopBookingConfig || global.WorkshopCityConfig;
    if (CFG) {
      CFG.readBootstrap(root);
      if (CFG.pollEnabled(root) === false) return;
    }

    root.__swcOnLiveUpdate = onUpdate;
    root.__swcRestartLivePoll = function () {
      startStateLivePoll(root, data, root.__swcOnLiveUpdate);
    };

    function deliverMerged(states) {
      var skeleton = root.__swcSkeletonCatalog || { cities: [] };
      var API2 = global.WorkshopCityEvents || {};
      var cities = (skeleton.cities || []).map(function (city) {
        return Object.assign({}, city, {
          slots:
            API2.mergeSlotsWithLive ? API2.mergeSlotsWithLive(city.slots, states) : city.slots,
        });
      });
      if (typeof onUpdate === 'function') {
        onUpdate(Object.assign({}, skeleton, { cities: cities }), states);
      }
    }

    root.__swcLivePoll = LiveAPI.startLiveStatePoll({
      root: root,
      catalogUrl: resolveLiveStateCatalogUrl(root),
      getPollContext: function () {
        var book = root.__swb;
        if (book && book.isOpen && book.isOpen()) return 'booking';
        return 'browsing';
      },
      getSlotGids: function () {
        return collectHorizonSlotGids(root.__swcSkeletonCatalog || {}, root, root.__swb);
      },
      onCatalog: function () {
        fetchStateCatalogEvents(root, data).then(function () {
          if (root.__swcLivePoll && typeof root.__swcLivePoll.refresh === 'function') {
            root.__swcLivePoll.refresh();
          }
        });
      },
      onUpdate: function (states, meta) {
        if (meta && CFG && typeof CFG.applyMetaFromResponse === 'function') {
          CFG.applyMetaFromResponse(root, meta).then(function () {
            deliverMerged(states);
          });
          return;
        }
        deliverMerged(states);
      },
    });
    if (CFG) {
      root.__wcfLastPollIntervalMs = CFG.activePollIntervalMs
        ? CFG.activePollIntervalMs(root)
        : CFG.pollIntervalMs(root, 'browsing');
    }
    root.__swcLivePoll.start();
  }

  function fetchStateCatalogEvents(root, data) {
    if (!API.fetchStateCatalog) return fetchAllProducts(root, data);

    var requestData = data;
    if (root.getAttribute('data-national') === 'true' || data.national) {
      requestData = Object.assign({}, data, { stateName: '', stateCode: '' });
    }

    return API.fetchStateCatalog(root, requestData, STATE_CATALOG_TIMEOUT_MS, {
      horizonDays: overlayHorizonDays(root),
    })
      .then(function (catalog) {
        var trimmed = trimCatalog(catalog, overlayHorizonDays(root));
        root.__swcSkeletonCatalog = trimmed;
        var maps = buildProductMaps(data.products);
        var events = catalogCitiesToEvents(trimmed, maps);
        if (!events.length && (data.products || []).length) {
          return fetchAllProducts(root, data);
        }
        return {
          events: events,
          stats: recomputeStatsFromEvents(events),
        };
      })
      .catch(function (err) {
        console.warn('[state-workshop-collection] state-events failed', err);
        return fetchAllProducts(root, data);
      });
  }

  function enrichEventsWithLive(root, events) {
    var LiveAPI = global.WorkshopCityEvents || {};
    if (!LiveAPI.fetchLiveState) return Promise.resolve(events || []);

    var gids = [];
    (events || []).forEach(function (ev) {
      if (ev.slot && ev.slot.gid) gids.push(ev.slot.gid);
    });
    if (!gids.length) return Promise.resolve(events || []);

    var url =
      typeof LiveAPI.resolveLiveStateApiUrl === 'function'
        ? LiveAPI.resolveLiveStateApiUrl(root, resolveLiveStateCatalogUrl(root))
        : resolveLiveStateCatalogUrl(root);

    return LiveAPI.fetchLiveState(gids, { url: url, timeoutMs: FETCH_TIMEOUT_MS, root: root })
      .then(function (r) {
        var states = (r && r.states) || {};
        return (events || [])
          .map(function (ev) {
            var slot =
              LiveAPI.mergeSlotWithLive && ev.slot
                ? LiveAPI.mergeSlotWithLive(ev.slot, states)
                : ev.slot;
            if (!slot) return null;
            return { slot: slot, product: ev.product };
          })
          .filter(Boolean);
      })
      .catch(function () {
        return events || [];
      });
  }

  function fetchAllProducts(root, data) {
    var products = data.products || [];
    if (!products.length || !API.fetchSlots) return Promise.resolve({ events: [], stats: {} });

    return Promise.all(
      products.map(function (p) {
        return API.fetchSlots(
          root,
          {
            productId: p.id,
            productHandle: p.handle,
            sectionId: data.sectionId,
          },
          undefined,
          { horizonDays: overlayHorizonDays(root) }
        )
          .then(function (slots) {
            return trimCitySlots(slots, overlayHorizonDays(root)).map(function (slot) {
              return { slot: slot, product: p };
            });
          })
          .catch(function (err) {
            console.warn('[state-workshop-collection]', p.handle, err);
            return [];
          });
      })
    )
      .then(function (groups) {
        return groups.reduce(function (acc, group) {
          return acc.concat(group);
        }, []);
      })
      .then(function (events) {
        return enrichEventsWithLive(root, events).then(function (liveEvents) {
          return { events: liveEvents, stats: recomputeStatsFromEvents(liveEvents) };
        });
      });
  }

  function useStateEventsApi(root) {
    return root.getAttribute('data-use-state-events-api') !== 'false';
  }

  function loadEvents(root, data) {
    API = global.WorkshopCityEvents || API;
    if (useStateEventsApi(root)) {
      return fetchStateCatalogEvents(root, data);
    }
    return fetchAllProducts(root, data);
  }

  function buildWorkshopTypes(products) {
    var map = {};
    (products || []).forEach(function (p) {
      var t = productType(p);
      if (!map[t.key]) map[t.key] = t;
    });
    return Object.keys(map)
      .map(function (k) {
        return map[k];
      })
      .sort(function (a, b) {
        var ia = TYPE_ORDER.indexOf(a.key);
        var ib = TYPE_ORDER.indexOf(b.key);
        if (ia === -1 && ib === -1) return a.label.localeCompare(b.label);
        if (ia === -1) return 1;
        if (ib === -1) return -1;
        return ia - ib;
      });
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatShortDate(dateKey) {
    var d = parseDateKey(dateKey);
    if (!d) return dateKey || '';
    return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  }

  function formatCardDate(dateKey) {
    var d = parseDateKey(dateKey);
    if (!d) return dateKey || '';
    var weekday = d.toLocaleDateString('en-US', { weekday: 'long' });
    var month = d.toLocaleDateString('en-US', { month: 'long' });
    return weekday + ' ' + d.getDate() + ' ' + month + ' ' + d.getFullYear();
  }

  function uniqueDateCount(events) {
    var keys = {};
    (events || []).forEach(function (ev) {
      var dk = slotDateKey(ev.slot);
      if (dk) keys[dk] = true;
    });
    return Object.keys(keys).length;
  }

  function slotTimeLabel(slot) {
    if (!slot) return '';
    var label = String(slot.time_label || '').trim();
    if (label) return label;
    var start = slot.schema_start || slot.starts_at || '';
    if (start.length >= 16) {
      var d = new Date(start);
      if (!isNaN(d.getTime())) {
        return d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
      }
    }
    return '';
  }

  function slotRank(slot) {
    var dk = slotDateKey(slot) || '9999-99-99';
    return dk + 'T' + String((slot && (slot.schema_start || slot.time_label)) || '');
  }

  function productSessionStats(events, dateRange) {
    var byHandle = {};
    (events || []).forEach(function (ev) {
      var p = ev.product;
      if (!p || !p.handle) return;
      var dk = slotDateKey(ev.slot);
      if (!dateInRange(dk, dateRange)) return;
      var rank = slotRank(ev.slot);
      var bookable = slotBookable(ev.slot);
      if (!byHandle[p.handle]) {
        byHandle[p.handle] = {
          next: dk,
          nextTime: slotTimeLabel(ev.slot),
          nextRank: rank,
          nextBookable: bookable,
          events: [],
          bookableCount: 0,
        };
      }
      var row = byHandle[p.handle];
      row.events.push(ev);
      if (bookable) row.bookableCount += 1;
      if (bookable && !row.nextBookable) {
        row.next = dk;
        row.nextTime = slotTimeLabel(ev.slot);
        row.nextRank = rank;
        row.nextBookable = true;
      } else if (bookable === row.nextBookable && rank < row.nextRank) {
        row.next = dk;
        row.nextTime = slotTimeLabel(ev.slot);
        row.nextRank = rank;
      }
    });
    Object.keys(byHandle).forEach(function (h) {
      byHandle[h].dateCount = uniqueDateCount(byHandle[h].events);
    });
    return byHandle;
  }

  function productCityKey(p) {
    var city = String((p && p.cityName) || '').trim() || 'City';
    var st = String((p && p.productState) || '').trim();
    return st ? city + '::' + st : city;
  }

  function productStateKey(p) {
    var raw = String((p && p.productState) || '').trim();
    if (!raw) return '';
    var upper = raw.toUpperCase();
    if (STATE_NAMES[upper]) return upper;
    var match = Object.keys(STATE_NAMES).filter(function (code) {
      return STATE_NAMES[code].toLowerCase() === raw.toLowerCase();
    })[0];
    return match || upper;
  }

  function stateChipLabel(code) {
    return STATE_NAMES[code] || code;
  }

  function groupProductsByCity(products, placeOpts) {
    var order = [];
    var map = {};
    var titles = {};
    placeOpts = placeOpts || {};
    (products || []).forEach(function (p) {
      var city = String(p.cityName || '').trim() || 'City';
      var st = String(p.productState || '').trim();
      var key = productCityKey(p);
      if (!map[key]) {
        var suffix = st || placeOpts.stateCode || '';
        if (!suffix && !placeOpts.national && placeOpts.stateName && placeOpts.stateName !== city) {
          suffix = placeOpts.stateName;
        }
        map[key] = [];
        order.push(key);
        titles[key] = suffix ? city + ', ' + suffix : city;
      }
      map[key].push(p);
    });
    order.forEach(function (city) {
      map[city].sort(function (a, b) {
        var ia = TYPE_ORDER.indexOf(productType(a).key);
        var ib = TYPE_ORDER.indexOf(productType(b).key);
        if (ia === -1 && ib === -1) return productType(a).label.localeCompare(productType(b).label);
        if (ia === -1) return 1;
        if (ib === -1) return -1;
        return ia - ib;
      });
    });
    return { order: order, map: map, titles: titles };
  }

  function initRoot(root) {
    if (root.__swcBound) return;
    root.__swcBound = true;

    if (global.WorkshopCityConfig && typeof global.WorkshopCityConfig.readBootstrap === 'function') {
      global.WorkshopCityConfig.readBootstrap(root);
    }

    var data = parseData(root);
    if (!data) return;

    var workshopTypes = buildWorkshopTypes(data.products || []);
    var productMaps = buildProductMaps(data.products);
    var book = global.StateWorkshopBook && global.StateWorkshopBook.bind(root);
    root.__wcfGetPollContext = function () {
      if (book && book.isOpen && book.isOpen()) return 'booking';
      return 'browsing';
    };
    var viewDatesLabel = root.getAttribute('data-book-label') || 'Book workshop';
    var soldOutLabel = root.getAttribute('data-sold-out-label') || 'Sold out';
    var waitlistLabel = root.getAttribute('data-waitlist-label') || 'Join waitlist';
    var isNational =
      root.getAttribute('data-national') === 'true' || data.national === true;
    var stateName = isNational ? '' : root.getAttribute('data-state-name') || data.stateName || '';
    var stateCode = isNational ? '' : root.getAttribute('data-state-code') || data.stateCode || '';
    var placeOpts = { national: isNational, stateCode: stateCode, stateName: stateName };
    var fallbacks = {
      mosaic: root.getAttribute('data-fallback-mosaic') || '',
      ceramic: root.getAttribute('data-fallback-ceramic') || '',
      resin: root.getAttribute('data-fallback-resin') || '',
      flower: root.getAttribute('data-fallback-flower') || '',
    };

    var defaultDateRange = String(root.getAttribute('data-default-date-range') || '30').trim();
    if (!defaultDateRange) defaultDateRange = '30';

    var cityPageSize = parseInt(root.getAttribute('data-city-page-size') || '4', 10) || 4;
    var allStatesLabel = root.getAttribute('data-all-states-label') || 'All';
    var moreCitiesLabel = root.getAttribute('data-more-cities-label') || 'Show more cities';

    var state = {
      allEvents: [],
      workshopType: 'all',
      dateRange: defaultDateRange,
      filterState: 'all',
      page: 1,
    };

    var els = {
      loading: root.querySelector('[data-swc-loading]'),
      status: root.querySelector('[data-swc-status]'),
      statusText: root.querySelector('[data-swc-status] .swc-status__text'),
      typeChips: root.querySelector('[data-swc-workshop-types]'),
      stateChips: root.querySelector('[data-swc-states]'),
      stateWrap: root.querySelector('[data-swc-state-wrap]'),
      whenSkel: root.querySelector('[data-swc-when-skel]'),
      dateFilters: root.querySelector('[data-swc-date-filters]'),
      find: root.querySelector('[data-swc-find]'),
      events: root.querySelector('[data-swc-events]'),
      more: root.querySelector('[data-swc-more]'),
      moreBtn: root.querySelector('[data-swc-more-btn]'),
      empty: root.querySelector('[data-swc-empty]'),
    };

    function hasReadyCards() {
      return !!(els.events && els.events.querySelector('.swc-card:not(.swc-card--skel)'));
    }

    function renderSkeletonCard() {
      return (
        '<article class="swc-card swc-card--skel" aria-hidden="true">' +
        '<div class="swc-card__media"><span class="swc-skel swc-skel--img"></span></div>' +
        '<div class="swc-card__body">' +
        '<div class="swc-card__top">' +
        '<span class="swc-skel swc-skel--badge"></span>' +
        '<span class="swc-skel swc-skel--price"></span>' +
        '</div>' +
        '<span class="swc-skel swc-skel--title"></span>' +
        '<div class="swc-card__schedule">' +
        '<p class="swc-card__when">' +
        '<span class="swc-skel swc-skel--date"></span>' +
        '<span class="swc-skel swc-skel--time"></span>' +
        '</p>' +
        '<span class="swc-skel swc-skel--more"></span>' +
        '</div>' +
        '<span class="swc-skel swc-skel--btn"></span>' +
        '</div></article>'
      );
    }

    function renderSkeleton() {
      if (!els.events) return;
      var grouped = groupProductsByCity(data.products || [], placeOpts);
      var order = grouped.order.slice(0, cityPageSize);
      if (!order.length) {
        grouped.map = { City: [1, 2], Nearby: [1, 2] };
        order = ['City', 'Nearby'];
      }
      els.events.setAttribute('aria-busy', 'true');
      els.events.innerHTML = order
        .map(function (city) {
          var count = (grouped.map[city] || []).length;
          var cards = '';
          var i;
          for (i = 0; i < count; i++) cards += renderSkeletonCard();
          return (
            '<section class="swc-city-block swc-city-block--skel" data-count="' +
            count +
            '">' +
            '<header class="swc-city-block__head">' +
            '<span class="swc-skel swc-skel--city"></span>' +
            '<span class="swc-skel swc-skel--count"></span>' +
            '</header>' +
            '<div class="swc-card-grid">' +
            cards +
            '</div></section>'
          );
        })
        .join('');
    }

    function renderTypeSkeleton() {
      if (!els.typeChips) return;
      els.typeChips.innerHTML =
        '<span class="swc-skel swc-skel--chip"></span>' +
        '<span class="swc-skel swc-skel--chip swc-skel--chip-md"></span>' +
        '<span class="swc-skel swc-skel--chip swc-skel--chip-lg"></span>' +
        '<span class="swc-skel swc-skel--chip"></span>' +
        '<span class="swc-skel swc-skel--chip swc-skel--chip-md"></span>';
    }

    function setLoading(on) {
      root.classList.toggle('is-loading', !!on);
      if (els.find) els.find.hidden = !on || hasReadyCards();
      if (els.whenSkel) els.whenSkel.hidden = !on;
      if (els.dateFilters) els.dateFilters.hidden = !!on;
      if (els.more && on) els.more.hidden = true;
      if (on) {
        if (els.typeChips && !els.typeChips.querySelector('[data-swc-type]') && !els.typeChips.querySelector('.swc-skel')) {
          renderTypeSkeleton();
        }
        if (els.events && !els.events.querySelector('.swc-card, .swc-city-block--skel')) {
          renderSkeleton();
        }
        if (els.events) els.events.setAttribute('aria-busy', 'true');
      }
      if (!on && els.events) els.events.removeAttribute('aria-busy');
    }

    function setDateRangeChip(activeKey) {
      root.querySelectorAll('[data-swc-date-range]').forEach(function (b) {
        var on = b.getAttribute('data-swc-date-range') === String(activeKey);
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function renderChip(value, label, selected, attr) {
      return (
        '<button type="button" class="swc-chip' +
        (selected ? ' is-active' : '') +
        '" ' +
        attr +
        '="' +
        escapeHtml(value) +
        '" aria-pressed="' +
        (selected ? 'true' : 'false') +
        '">' +
        escapeHtml(label) +
        '</button>'
      );
    }

    function typeChipLabel(type) {
      if (!type || type.key === 'all') return 'All';
      if (type.key === 'flower') return 'Flower';
      return type.label;
    }

    function renderTypeChips() {
      if (!els.typeChips) return;
      var html = renderChip('all', 'All', state.workshopType === 'all', 'data-swc-type');
      workshopTypes.forEach(function (t) {
        html += renderChip(t.key, typeChipLabel(t), state.workshopType === t.key, 'data-swc-type');
      });
      els.typeChips.innerHTML = html;
    }

    function visibleProducts() {
      var stats = productSessionStats(state.allEvents, state.dateRange);
      return (data.products || []).filter(function (p) {
        var t = productType(p);
        if (state.workshopType !== 'all' && t.key !== state.workshopType) return false;
        if (state.filterState !== 'all' && productStateKey(p) !== state.filterState) return false;
        if (state.dateRange && state.dateRange !== 'all') {
          return !!(stats[p.handle] && stats[p.handle].dateCount);
        }
        return true;
      });
    }

    function availableStates() {
      var map = {};
      (data.products || []).forEach(function (p) {
        var code = productStateKey(p);
        if (code) map[code] = true;
      });
      return Object.keys(map).sort(function (a, b) {
        return stateChipLabel(a).localeCompare(stateChipLabel(b));
      });
    }

    function renderStateChips() {
      if (!els.stateChips) return;
      var codes = availableStates();
      if (state.filterState !== 'all' && codes.indexOf(state.filterState) === -1) {
        state.filterState = 'all';
      }
      var html = renderChip('all', allStatesLabel, state.filterState === 'all', 'data-swc-state');
      codes.forEach(function (code) {
        html += renderChip(code, stateChipLabel(code), state.filterState === code, 'data-swc-state');
      });
      els.stateChips.innerHTML = html;
      if (els.stateWrap) els.stateWrap.hidden = codes.length < 2;
    }

    function updateMore(remaining) {
      if (!els.more) return;
      if (remaining <= 0) {
        els.more.hidden = true;
        return;
      }
      els.more.hidden = false;
      if (els.moreBtn) {
        els.moreBtn.textContent = moreCitiesLabel + ' · ' + remaining + ' more';
      }
    }

    function cityPlace(key, grouped) {
      if (grouped && grouped.titles && grouped.titles[key]) return grouped.titles[key];
      var city = String(key || '').split('::')[0];
      if (stateCode) return city + ', ' + stateCode;
      if (stateName) return city + ', ' + stateName;
      return city;
    }

    function renderCard(product, stats, eager) {
      var t = productType(product);
      var st = stats[product.handle] || {};
      var title = TYPE_TITLES[t.key] || product.workshopLabel || product.title;
      var seoTitle = product.title || title;
      var badge = TYPE_BADGES[t.key] || t.label;
      var img = product.featuredImageUrl || fallbacks[t.key] || '';
      var href = product.url || '/products/' + product.handle;
      var dateText = st.next ? formatCardDate(st.next) : '';
      var timeText = st.nextTime || '';
      var moreDates = st.dateCount > 1;
      var soldOut = !st.bookableCount;
      var ctaLabel = soldOut ? waitlistLabel : viewDatesLabel;
      var imgHtml = img
        ? '<img class="swc-card__img" src="' +
          escapeHtml(cardImageUrl(img, 640)) +
          '" srcset="' +
          escapeHtml(cardImageUrl(img, 360)) +
          ' 360w, ' +
          escapeHtml(cardImageUrl(img, 640)) +
          ' 640w" sizes="(max-width: 749px) 92vw, (max-width: 989px) 46vw, 280px" alt="' +
          escapeHtml(seoTitle) +
          '" width="640" height="480" decoding="async" loading="' +
          (eager ? 'eager' : 'lazy') +
          '"' +
          (eager ? ' fetchpriority="high"' : '') +
          '>'
        : '<span class="swc-card__img swc-card__img--placeholder" aria-hidden="true"></span>';
      var schedule = '';
      if (dateText || timeText || moreDates) {
        schedule =
          '<div class="swc-card__schedule">' +
          (dateText ? '<p class="swc-card__date">' + escapeHtml(dateText) + '</p>' : '') +
          '<div class="swc-card__slot">' +
          (timeText ? '<p class="swc-card__time">' + escapeHtml(timeText) + '</p>' : '') +
          '<p class="swc-card__dates">' +
          (moreDates ? 'More dates available' : '') +
          '</p></div></div>';
      }

      return (
        '<article class="swc-card swc-card--' +
        escapeHtml(t.key) +
        '">' +
        '<a class="swc-card__media" href="' +
        escapeHtml(href) +
        '">' +
        imgHtml +
        '</a>' +
        '<div class="swc-card__body">' +
        '<div class="swc-card__top">' +
        '<p class="swc-card__badge">' +
        escapeHtml(badge) +
        '</p>' +
        (product.priceFormatted
          ? '<p class="swc-card__price' +
            (product.compareAtFormatted ? ' swc-card__price--sale' : '') +
            '">From ' +
            (product.compareAtFormatted
              ? '<s>' + escapeHtml(product.compareAtFormatted) + '</s> '
              : '') +
            escapeHtml(product.priceFormatted) +
            '</p>'
          : '') +
        '</div>' +
        '<h3 class="swc-card__title">' +
        '<a href="' +
        escapeHtml(href) +
        '" aria-label="' +
        escapeHtml(seoTitle) +
        '">' +
        escapeHtml(title) +
        '</a></h3>' +
        (seoTitle && seoTitle !== title
          ? '<p class="swc-card__product">' + escapeHtml(seoTitle) + '</p>'
          : '') +
        schedule +
        (soldOut ? '<p class="swc-card__sold">' + escapeHtml(soldOutLabel) + '</p>' : '') +
        '<a class="swc-card__cta' +
        (soldOut ? ' is-soldout' : '') +
        '" href="' +
        escapeHtml(href) +
        '" data-swc-book data-handle="' +
        escapeHtml(product.handle || '') +
        '">' +
        escapeHtml(ctaLabel) +
        '</a></div></article>'
      );
    }

    function applyFilters(opts) {
      opts = opts || {};
      if (opts.resetPage) state.page = 1;
      var stats = productSessionStats(state.allEvents, state.dateRange);
      var sig = cardsSignature(
        stats,
        state.workshopType,
        state.dateRange,
        state.filterState,
        state.page
      );
      if (
        !opts.force &&
        sig === state.cardSig &&
        els.events &&
        els.events.querySelector('.swc-card:not(.swc-card--skel)')
      ) {
        return;
      }
      state.cardSig = sig;
      var products = visibleProducts();
      var grouped = groupProductsByCity(products, placeOpts);

      grouped.order.sort(function (a, b) {
        var aNext = grouped.map[a].reduce(function (min, p) {
          var n = stats[p.handle] && stats[p.handle].next;
          return n && n < min ? n : min;
        }, '9999');
        var bNext = grouped.map[b].reduce(function (min, p) {
          var n = stats[p.handle] && stats[p.handle].next;
          return n && n < min ? n : min;
        }, '9999');
        if (aNext !== bNext) return aNext.localeCompare(bNext);
        return a.localeCompare(b);
      });

      var visibleOrder = grouped.order.slice(0, state.page * cityPageSize);
      var remaining = grouped.order.length - visibleOrder.length;

      if (els.events) {
        if (!visibleOrder.length) {
          els.events.innerHTML = '<p class="swc-events__none">No workshops match these filters.</p>';
        } else {
          els.events.innerHTML = visibleOrder
            .map(function (city) {
              var cityProducts = grouped.map[city];
              var cards = cityProducts
                .map(function (p, idx) {
                  return renderCard(p, stats, city === visibleOrder[0] && idx < 2);
                })
                .join('');
              var countLabel =
                cityProducts.length +
                ' workshop' +
                (cityProducts.length === 1 ? '' : 's');
              return (
                '<section class="swc-city-block" data-count="' +
                cityProducts.length +
                '">' +
                '<header class="swc-city-block__head">' +
                '<h2 class="swc-city-block__title">' +
                '<span class="swc-city-block__pin" aria-hidden="true"></span>' +
                escapeHtml(cityPlace(city, grouped)) +
                '</h2>' +
                '<p class="swc-city-block__meta">' +
                escapeHtml(countLabel) +
                '</p></header>' +
                '<div class="swc-card-grid">' +
                cards +
                '</div></section>'
              );
            })
            .join('');
        }
      }

      updateMore(remaining);

      var statusEl = els.statusText || els.status;
      if (statusEl) {
        var shown = 0;
        visibleOrder.forEach(function (city) {
          shown += (grouped.map[city] || []).length;
        });
        statusEl.textContent =
          (remaining > 0 ? shown + ' of ' + products.length : String(products.length)) +
          ' workshop' +
          (products.length === 1 ? '' : 's');
      }

      if (els.empty) els.empty.hidden = !!(state.allEvents.length || products.length);
      renderTypeChips();
      renderStateChips();
    }

    function prefetchVisibleBookProducts() {
      var Book = global.StateWorkshopBook;
      if (!Book || !Book.prefetch || !els.events) return;
      var buttons = els.events.querySelectorAll('[data-swc-book]');
      var limit = Math.min(2, buttons.length);
      var i = 0;
      function next() {
        if (i >= limit) return;
        var handle = buttons[i].getAttribute('data-handle');
        i += 1;
        if (handle) Book.prefetch(handle);
        if (i < limit) {
          if (window.requestIdleCallback) window.requestIdleCallback(next, { timeout: 1400 });
          else setTimeout(next, 240);
        }
      }
      if (window.requestIdleCallback) window.requestIdleCallback(next, { timeout: 1400 });
      else setTimeout(next, 400);
    }

    function refreshOpenSlotsLive(handle, slots) {
      var LiveAPI = global.WorkshopCityEvents || {};
      if (!LiveAPI.fetchLiveState || !slots || !slots.length) return;
      var gids = [];
      slots.forEach(function (slot) {
        if (slot && slot.gid) gids.push(slot.gid);
      });
      if (!gids.length) return;
      var url =
        typeof LiveAPI.resolveLiveStateApiUrl === 'function'
          ? LiveAPI.resolveLiveStateApiUrl(root, resolveLiveStateCatalogUrl(root))
          : resolveLiveStateCatalogUrl(root);
      LiveAPI.fetchLiveState(gids, { url: url, timeoutMs: FETCH_TIMEOUT_MS, root: root })
        .then(function (r) {
          if (!book || !book.isOpen || !book.isOpen()) return;
          if (book.currentHandle && book.currentHandle() !== handle) return;
          var merged = LiveAPI.mergeSlotsWithLive
            ? LiveAPI.mergeSlotsWithLive(slots, (r && r.states) || {}, r && r.as_of)
            : slots;
          if (book.applySlots) book.applySlots(merged);
        })
        .catch(function () {});
    }

    root.addEventListener(
      'pointerenter',
      function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('[data-swc-book]') : null;
        if (!btn || !root.contains(btn)) return;
        var handle = btn.getAttribute('data-handle');
        if (handle && global.StateWorkshopBook && global.StateWorkshopBook.prefetch) {
          global.StateWorkshopBook.prefetch(handle);
        }
      },
      true
    );

    root.addEventListener('click', function (e) {
      var bookBtn = e.target.closest('[data-swc-book]');
      if (bookBtn && root.contains(bookBtn)) {
        e.preventDefault();
        var handle = bookBtn.getAttribute('data-handle') || '';
        var product = (data.products || []).filter(function (p) {
          return p.handle === handle;
        })[0];
        if (!book) book = global.StateWorkshopBook && global.StateWorkshopBook.bind(root);
        if (!product || !book) return;
        var slots = state.allEvents
          .filter(function (ev) {
            return ev.product && ev.product.handle === handle;
          })
          .map(function (ev) {
            return ev.slot;
          });
        var st = productSessionStats(state.allEvents, state.dateRange)[handle] || {};
        book.open(product, slots, { date: st.next, time: st.nextTime });
        refreshOpenSlotsLive(handle, slots);
        if (root.__swcLivePoll && root.__swcLivePoll.syncInterval) {
          root.__swcLivePoll.syncInterval();
        }
        return;
      }

      var typeBtn = e.target.closest('[data-swc-type]');
      if (typeBtn && els.typeChips && els.typeChips.contains(typeBtn)) {
        state.workshopType = typeBtn.getAttribute('data-swc-type') || 'all';
        applyFilters({ force: true, resetPage: true });
        return;
      }

      var stateBtn = e.target.closest('[data-swc-state]');
      if (stateBtn && els.stateChips && els.stateChips.contains(stateBtn)) {
        state.filterState = stateBtn.getAttribute('data-swc-state') || 'all';
        applyFilters({ force: true, resetPage: true });
        return;
      }

      var rangeBtn = e.target.closest('[data-swc-date-range]');
      if (rangeBtn) {
        e.preventDefault();
        state.dateRange = rangeBtn.getAttribute('data-swc-date-range') || 'all';
        setDateRangeChip(state.dateRange);
        applyFilters({ force: true, resetPage: true });
        return;
      }

      var moreBtn = e.target.closest('[data-swc-more-btn]');
      if (moreBtn && root.contains(moreBtn)) {
        e.preventDefault();
        state.page += 1;
        applyFilters({ force: true });
      }
    });

    function takeUpcoming(events) {
      return (events || []).filter(function (ev) {
        return isUpcomingDate(slotDateKey(ev.slot));
      });
    }

    function applyLiveCatalog(liveCatalog, states) {
      var events = catalogCitiesToEvents(liveCatalog, productMaps);
      state.allEvents = takeUpcoming(events);
      applyFilters();
      if (book && book.isOpen && book.isOpen() && book.applySlots) {
        var handle = book.currentHandle ? book.currentHandle() : '';
        if (handle) {
          var LiveAPI = global.WorkshopCityEvents || {};
          var base =
            book.currentSlots && book.currentSlots().length
              ? book.currentSlots()
              : state.allEvents
                  .filter(function (ev) {
                    return ev.product && ev.product.handle === handle;
                  })
                  .map(function (ev) {
                    return ev.slot;
                  });
          var merged =
            LiveAPI.mergeSlotsWithLive && states
              ? LiveAPI.mergeSlotsWithLive(base, states)
              : base;
          book.applySlots(merged);
        }
      }
    }

    setDateRangeChip(state.dateRange);
    setLoading(true);
    if (els.empty) els.empty.hidden = true;

    loadEvents(root, data).then(function (result) {
      var events = (result && result.events) || [];
      state.allEvents = takeUpcoming(events);

      if (defaultDateRange && defaultDateRange !== 'all' && state.allEvents.length) {
        var ranged = productSessionStats(state.allEvents, state.dateRange);
        var any = (data.products || []).some(function (p) {
          return ranged[p.handle] && ranged[p.handle].dateCount;
        });
        if (!any) {
          state.dateRange = 'all';
          setDateRangeChip('all');
        }
      }

      applyFilters({ force: true });
      setLoading(false);
      prefetchVisibleBookProducts();

      if (useStateEventsApi(root) && root.__swcSkeletonCatalog) {
        startStateLivePoll(root, data, applyLiveCatalog);
      }
    });
  }

  function boot(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-state-workshop-collection]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('[data-state-workshop-collection]').forEach(function (el) {
      stopStateLivePoll(el);
      delete el.__swcBound;
      delete el.__wcfBookingConfig;
      delete el.__wcfLastPollIntervalMs;
      delete el.__swcRestartLivePoll;
      delete el.__swcOnLiveUpdate;
      delete el.__swcSkeletonCatalog;
      delete el.__swb;
      delete el.__wcfGetPollContext;
      initRoot(el);
    });
  });
})(typeof window !== 'undefined' ? window : this);
